import React from 'react';
import { contactData } from '../data/mock';

const DatenschutzPage = () => {
  return (
    <div style={{ background: '#000000', position: 'relative' }}>
      <div className="pattern-overlay" />
      
      <section style={{ paddingTop: '140px', paddingBottom: '80px', position: 'relative' }}>
        <div className="container mx-auto px-4" style={{ maxWidth: '900px' }}>
          <h1 className="display-large" style={{ 
            marginBottom: '60px',
            animation: 'fade-in-up 0.8s ease-out'
          }}>
            Datenschutzerklärung
          </h1>

          <div className="glass-card" style={{
            padding: '40px',
            animation: 'fade-in-up 0.8s ease-out 0.2s both'
          }}>
            <div style={{ lineHeight: '1.8' }}>
              <h2 className="heading-1" style={{ marginBottom: '20px', color: '#00A8CC' }}>
                1. Datenschutz auf einen Blick
              </h2>
              
              <div style={{ marginBottom: '32px' }}>
                <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                  Allgemeine Hinweise
                </h3>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '16px' }}>
                  Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                </p>
              </div>

              <div style={{
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                paddingTop: '32px',
                marginBottom: '32px'
              }}>
                <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                  Datenerfassung auf unserer Website
                </h3>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '16px' }}>
                  <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br/>
                  Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
                </p>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '16px' }}>
                  <strong>Wie erfassen wir Ihre Daten?</strong><br/>
                  Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
                </p>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
                </p>
              </div>

              <div style={{
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                paddingTop: '32px',
                marginBottom: '32px'
              }}>
                <h2 className="heading-1" style={{ marginBottom: '20px', color: '#00A8CC' }}>
                  2. Allgemeine Hinweise und Pflichtinformationen
                </h2>
                
                <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                  Datenschutz
                </h3>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '16px' }}>
                  Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                </p>
              </div>

              <div style={{
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                paddingTop: '32px',
                marginBottom: '32px'
              }}>
                <h2 className="heading-1" style={{ marginBottom: '20px', color: '#00A8CC' }}>
                  3. Datenerfassung auf unserer Website
                </h2>
                
                <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                  Kontaktformular
                </h3>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '16px' }}>
                  Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
                </p>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                </p>
              </div>

              <div style={{
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                paddingTop: '32px',
                marginBottom: '32px'
              }}>
                <h2 className="heading-1" style={{ marginBottom: '20px', color: '#00A8CC' }}>
                  4. Ihre Rechte
                </h2>
                
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '16px' }}>
                  Sie haben jederzeit das Recht:
                </p>
                <ul style={{ 
                  listStyleType: 'disc',
                  paddingLeft: '24px',
                  color: 'rgba(255, 255, 255, 0.7)',
                  fontSize: '16px',
                  lineHeight: '1.8'
                }}>
                  <li style={{ marginBottom: '8px' }}>Auskunft über Ihre bei uns gespeicherten Daten zu erhalten</li>
                  <li style={{ marginBottom: '8px' }}>Berichtigung unrichtiger Daten zu verlangen</li>
                  <li style={{ marginBottom: '8px' }}>Löschung Ihrer Daten zu verlangen</li>
                  <li style={{ marginBottom: '8px' }}>Einschränkung der Datenverarbeitung zu verlangen</li>
                  <li style={{ marginBottom: '8px' }}>Datenübertragbarkeit zu verlangen</li>
                  <li>Widerspruch gegen die Datenverarbeitung einzulegen</li>
                </ul>
              </div>

              <div style={{
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                paddingTop: '32px'
              }}>
                <h2 className="heading-1" style={{ marginBottom: '20px', color: '#00A8CC' }}>
                  5. Kontakt
                </h2>
                
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '8px' }}>
                  Bei Fragen zum Datenschutz können Sie sich jederzeit an uns wenden:
                </p>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)', marginBottom: '8px' }}>
                  <strong>Telefon:</strong> {contactData.phone}
                </p>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  <strong>E-Mail:</strong> {contactData.email}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DatenschutzPage;